var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUmbrella({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 18L7 19C7 20.6569 8.34315 22 10 22C11.6569 22 13 20.6569 13 19L13 1C13 0.447715 12.5523 1.23489e-07 12 2.18557e-07C11.4477 1.94416e-07 11 0.447715 11 1L11 19C11 19.5523 10.5523 20 10 20C9.44771 20 9 19.5523 9 19L9 18L7 18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.7639L4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10L20 11.7639C19.4692 11.2889 18.7684 11 18 11C17.2316 11 16.5308 11.2889 16 11.7639C15.4692 11.2889 14.7684 11 14 11C13.2316 11 12.5308 11.2889 12 11.7639C11.4692 11.2889 10.7684 11 10 11C9.23165 11 8.53076 11.2889 8 11.7639C7.46924 11.2889 6.76835 11 6 11C5.23165 11 4.53076 11.2889 4 11.7639Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUmbrella);
export default __webpack_public_path__ + "static/media/ic_action_umbrella.d90fd2b104f9613143a38ef7bf8ea992.svg";
export { ForwardRef as ReactComponent };